import { useChatTransport as e } from "../transport/ChatTransportContext.mjs";
import { useInfiniteList as t, useInfiniteQuery as n } from "@maat/store-hooks";
//#region src/hooks/useInternalNotesQuery.ts
var r = 50, i = (i) => {
	let { api: a, keys: o } = e();
	return t(n({
		queryKey: o.internalNotes(i),
		queryFn: async ({ pageParam: e }) => a.getInternalNotes(i, {
			limit: r,
			offset: e
		}),
		initialPageParam: 0,
		getNextPageParam: (e, t) => e.hasMore ? t.reduce((e, t) => e + t.notes.length, 0) : void 0,
		enabled: !!i
	}), "notes");
};
//#endregion
export { i as useInternalNotesQuery };
